export const generatedBuilderThemePresetCatalog = [
  {
    "id": "real_estate",
    "labelKey": "project.builder.themePresets.real_estate.label",
    "descriptionKey": "project.builder.themePresets.real_estate.description",
    "preview": {
      "accentColor": "#17324d",
      "surfaceColor": "#f2ece2",
      "title": "Urban Prime",
      "subtitle": "Property showcase"
    },
    "tokens": {
      "accent": "#17324d",
      "accentStrong": "#0d2236",
      "surface": "#f2ece2",
      "surfaceStrong": "#fffdf8",
      "surfaceMuted": "#e2d8c8",
      "text": "#14202b",
      "muted": "#6f6a61",
      "copy": "#4e5359",
      "border": "#d9cfbf",
      "highlight": "#c59063",
      "heroSurface": "#17324d",
      "heroText": "#ffffff",
      "cardSurface": "#fffaf4"
    },
    "components": {
      "hero": "editorial",
      "section": "property",
      "card": "property",
      "stats": "dense",
      "cta": "band",
      "gallery": "showcase"
    },
    "starterPages": {
      "homepage": {
        "title": "Homepage",
        "slug": "homepage",
        "pageType": "homepage",
        "menuLocation": "primary",
        "seoTitle": "Agentie imobiliara premium",
        "seoDescription": "Prezentare clara pentru proprietati, consultanta si lead-uri calificate.",
        "sections": [
          {
            "type": "hero",
            "props": {
              "eyebrow": "Consultanta imobiliara premium",
              "heading": "Proprietati selectate pentru clienti care vor claritate si viteza",
              "subheading": "Listari premium, consultanta de achizitie si suport complet pentru vanzare sau inchiriere.",
              "primaryCta": {
                "label": "Programeaza consultanta",
                "href": "#contact",
                "style": "primary"
              },
              "secondaryCta": {
                "label": "Vezi proprietatile",
                "href": "#proprietati",
                "style": "secondary"
              },
              "media": {
                "assetId": null,
                "altText": "Interior proprietate premium"
              },
              "alignment": "start"
            }
          },
          {
            "type": "stats",
            "props": {
              "heading": "Performanta care conteaza",
              "intro": "Indicatori rapizi pentru incredere imediata.",
              "items": [
                {
                  "value": "120+",
                  "label": "proprietati promovate"
                },
                {
                  "value": "28 zile",
                  "label": "timp mediu de tranzactionare"
                },
                {
                  "value": "92%",
                  "label": "lead-uri validate"
                }
              ]
            }
          },
          {
            "type": "services",
            "props": {
              "heading": "Servicii",
              "intro": "Pachete orientate spre listare, achizitie si negociere.",
              "items": [
                {
                  "title": "Vanzare proprietati",
                  "description": "Strategie de listare, promovare si calificare lead-uri.",
                  "icon": {
                    "assetId": null,
                    "altText": "Icon vanzare"
                  }
                },
                {
                  "title": "Consultanta cumparatori",
                  "description": "Filtrare oportunitati si suport pana la semnare.",
                  "icon": {
                    "assetId": null,
                    "altText": "Icon consultanta"
                  }
                },
                {
                  "title": "Administrare inchirieri",
                  "description": "Flux clar pentru proprietari care vor predictibilitate.",
                  "icon": {
                    "assetId": null,
                    "altText": "Icon inchirieri"
                  }
                }
              ]
            }
          },
          {
            "type": "features",
            "props": {
              "heading": "De ce functioneaza",
              "intro": "Proces de lucru gandit pentru decizii rapide si documentate.",
              "items": [
                {
                  "title": "Selectie relevanta",
                  "description": "Eliminam zgomotul si raman doar oportunitatile utile."
                },
                {
                  "title": "Prezentare premium",
                  "description": "Structura vizuala si copy orientate spre conversie."
                },
                {
                  "title": "Negociere ghidata",
                  "description": "Gestionam pasii critici pana la oferta finala."
                }
              ]
            }
          },
          {
            "type": "gallery",
            "props": {
              "heading": "Proprietati in focus",
              "intro": "Exemple de spatii prezentate cu claritate si ritm premium.",
              "items": [
                {
                  "image": {
                    "assetId": null,
                    "altText": "Apartament modern"
                  },
                  "caption": "Apartament central cu terasa mare"
                },
                {
                  "image": {
                    "assetId": null,
                    "altText": "Casa contemporana"
                  },
                  "caption": "Casa de familie cu curte privata"
                },
                {
                  "image": {
                    "assetId": null,
                    "altText": "Spatiu comercial"
                  },
                  "caption": "Spatiu comercial pentru trafic premium"
                }
              ]
            }
          },
          {
            "type": "testimonials",
            "props": {
              "heading": "Clientii spun direct",
              "intro": "Testimoniale care reduc frictiunea inainte de contact.",
              "items": [
                {
                  "quote": "Am vandut mai repede decat estimam si cu un proces foarte clar.",
                  "author": "Radu M.",
                  "role": "Proprietar"
                },
                {
                  "quote": "Am vazut doar proprietati relevante si am luat decizia fara pierderi de timp.",
                  "author": "Andreea P.",
                  "role": "Cumparator"
                }
              ]
            }
          },
          {
            "type": "faq",
            "props": {
              "heading": "Intrebari frecvente",
              "intro": "Raspunsuri rapide pentru pasii initiali.",
              "items": [
                {
                  "question": "Cum incepe colaborarea?",
                  "answer": "Stabilim obiectivul, tipul de proprietate si filtram oferta relevanta."
                },
                {
                  "question": "Ce include promovarea?",
                  "answer": "Prezentare, structurare listing, comunicare si urmarirea lead-urilor."
                }
              ]
            }
          },
          {
            "type": "cta",
            "props": {
              "heading": "Spune-ne ce proprietate cauti sau ce vrei sa listezi",
              "body": "Pornim cu o discutie scurta si un plan clar pentru urmatorii pasi.",
              "primaryCta": {
                "label": "Solicita consultanta",
                "href": "#contact",
                "style": "primary"
              },
              "secondaryCta": {
                "label": "Vezi serviciile",
                "href": "#servicii",
                "style": "secondary"
              }
            }
          },
          {
            "type": "footer",
            "props": {
              "companyName": "Urban Prime",
              "tagline": "Consultanta imobiliara orientata spre viteza, selectie si claritate.",
              "links": [
                {
                  "label": "Acasa",
                  "href": "#top"
                },
                {
                  "label": "Servicii",
                  "href": "#servicii"
                },
                {
                  "label": "Contact",
                  "href": "#contact"
                }
              ],
              "contactEmail": "contact@urbanprime.ro",
              "contactPhone": "+40 745 000 000"
            }
          }
        ]
      }
    }
  },
  {
    "id": "dental_clinic",
    "labelKey": "project.builder.themePresets.dental_clinic.label",
    "descriptionKey": "project.builder.themePresets.dental_clinic.description",
    "preview": {
      "accentColor": "#0f6c78",
      "surfaceColor": "#edf7f6",
      "title": "Care Grid",
      "subtitle": "Clinical clarity"
    },
    "tokens": {
      "accent": "#0f6c78",
      "accentStrong": "#0a525c",
      "surface": "#edf7f6",
      "surfaceStrong": "#ffffff",
      "surfaceMuted": "#dceceb",
      "text": "#13363b",
      "muted": "#5f7a7d",
      "copy": "#486266",
      "border": "#cfe2e0",
      "highlight": "#79c3bf",
      "heroSurface": "#0f6c78",
      "heroText": "#ffffff",
      "cardSurface": "#ffffff"
    },
    "components": {
      "hero": "clinical",
      "section": "clinical",
      "card": "trust",
      "stats": "calm",
      "cta": "appointment",
      "gallery": "calm"
    },
    "starterPages": {
      "homepage": {
        "title": "Homepage",
        "slug": "homepage",
        "pageType": "homepage",
        "menuLocation": "primary",
        "seoTitle": "Clinica dentara moderna",
        "seoDescription": "Prezentare clara pentru servicii, incredere si programari rapide.",
        "sections": [
          {
            "type": "hero",
            "props": {
              "eyebrow": "Clinica dentara",
              "heading": "Tratamente explicate clar, intr-un cadru calm si profesionist",
              "subheading": "Consultatii, implantologie, estetica si profilaxie cu accent pe confort si predictibilitate.",
              "primaryCta": {
                "label": "Programeaza consultatia",
                "href": "#contact",
                "style": "primary"
              },
              "secondaryCta": {
                "label": "Vezi serviciile",
                "href": "#servicii",
                "style": "secondary"
              },
              "media": {
                "assetId": null,
                "altText": "Cabinet dentar modern"
              },
              "alignment": "start"
            }
          },
          {
            "type": "about",
            "props": {
              "heading": "Despre clinica",
              "intro": "Un mesaj de incredere pentru prima interactiune.",
              "body": "Punem accent pe comunicare, planuri de tratament clare si o experienta fara stres pentru pacient.",
              "highlights": [
                "Echipa multidisciplinara",
                "Plan de tratament explicat clar",
                "Tehnologie actuala si programari rapide"
              ]
            }
          },
          {
            "type": "services",
            "props": {
              "heading": "Servicii principale",
              "intro": "Structurate pentru a fi usor de scanat si usor de inteles.",
              "items": [
                {
                  "title": "Implantologie",
                  "description": "Solutii stabile, cu etape explicate clar inainte de tratament.",
                  "icon": {
                    "assetId": null,
                    "altText": "Icon implantologie"
                  }
                },
                {
                  "title": "Ortodontie",
                  "description": "Planuri adaptate, monitorizare constanta si rezultate previzibile.",
                  "icon": {
                    "assetId": null,
                    "altText": "Icon ortodontie"
                  }
                },
                {
                  "title": "Profilaxie si estetica",
                  "description": "Preventie si imbunatatiri estetice sustinute de recomandari clare.",
                  "icon": {
                    "assetId": null,
                    "altText": "Icon profilaxie"
                  }
                }
              ]
            }
          },
          {
            "type": "steps",
            "props": {
              "heading": "Cum decurge colaborarea",
              "intro": "Pasii principali explicati fara jargon inutil.",
              "items": [
                {
                  "title": "Consultatie initiala",
                  "description": "Evaluare, discutie despre simptome si obiective."
                },
                {
                  "title": "Plan de tratament",
                  "description": "Explicam etapele, costurile si prioritatile."
                },
                {
                  "title": "Interventie si monitorizare",
                  "description": "Tratament organizat si controale programate clar."
                }
              ]
            }
          },
          {
            "type": "stats",
            "props": {
              "heading": "Date rapide",
              "intro": "Repere utile pentru incredere imediata.",
              "items": [
                {
                  "value": "15+",
                  "label": "ani experienta cumulata"
                },
                {
                  "value": "4.9/5",
                  "label": "rating pacienti"
                },
                {
                  "value": "48h",
                  "label": "interval pentru consultatie"
                }
              ]
            }
          },
          {
            "type": "testimonials",
            "props": {
              "heading": "Feedback pacienti",
              "intro": "Mesaje scurte, credibile si usor de scanat.",
              "items": [
                {
                  "quote": "Totul a fost explicat clar si m-am simtit in siguranta la fiecare pas.",
                  "author": "Ioana C.",
                  "role": "Pacienta"
                },
                {
                  "quote": "Programare rapida, echipa calma si rezultate foarte bune.",
                  "author": "Mihai T.",
                  "role": "Pacient"
                }
              ]
            }
          },
          {
            "type": "faq",
            "props": {
              "heading": "Intrebari frecvente",
              "intro": "Raspunsuri rapide pentru primele nelamuriri.",
              "items": [
                {
                  "question": "Cat dureaza consultatia initiala?",
                  "answer": "De regula intre 30 si 45 de minute, in functie de situatie."
                },
                {
                  "question": "Primesc plan de tratament scris?",
                  "answer": "Da, dupa evaluare definim pasii, prioritatile si costurile estimative."
                }
              ]
            }
          },
          {
            "type": "cta",
            "props": {
              "heading": "Programeaza o discutie initiala fara presiune",
              "body": "Te ajutam sa intelegi optiunile si urmatorii pasi intr-un mod clar si calm.",
              "primaryCta": {
                "label": "Fa o programare",
                "href": "#contact",
                "style": "primary"
              },
              "secondaryCta": {
                "label": "Vezi tratamentele",
                "href": "#tratamente",
                "style": "secondary"
              }
            }
          },
          {
            "type": "footer",
            "props": {
              "companyName": "Care Grid Dental",
              "tagline": "Claritate medicala, comunicare calma si tratamente explicate pas cu pas.",
              "links": [
                {
                  "label": "Acasa",
                  "href": "#top"
                },
                {
                  "label": "Servicii",
                  "href": "#servicii"
                },
                {
                  "label": "Contact",
                  "href": "#contact"
                }
              ],
              "contactEmail": "programari@caregrid.ro",
              "contactPhone": "+40 721 000 000"
            }
          }
        ]
      }
    }
  },
  {
    "id": "beauty_clinic",
    "labelKey": "project.builder.themePresets.beauty_clinic.label",
    "descriptionKey": "project.builder.themePresets.beauty_clinic.description",
    "preview": {
      "accentColor": "#5f4b52",
      "surfaceColor": "#f6efef",
      "title": "Soft Contour",
      "subtitle": "Beauty editorial"
    },
    "tokens": {
      "accent": "#5f4b52",
      "accentStrong": "#45363b",
      "surface": "#f6efef",
      "surfaceStrong": "#fffafb",
      "surfaceMuted": "#ebdddd",
      "text": "#2c2528",
      "muted": "#77666c",
      "copy": "#5e5156",
      "border": "#e1d3d6",
      "highlight": "#c9a3ae",
      "heroSurface": "#5f4b52",
      "heroText": "#ffffff",
      "cardSurface": "#fffafb"
    },
    "components": {
      "hero": "soft",
      "section": "editorial",
      "card": "soft",
      "stats": "calm",
      "cta": "editorial",
      "gallery": "showcase"
    },
    "starterPages": {}
  },
  {
    "id": "restaurant",
    "labelKey": "project.builder.themePresets.restaurant.label",
    "descriptionKey": "project.builder.themePresets.restaurant.description",
    "preview": {
      "accentColor": "#76351f",
      "surfaceColor": "#f8f0e8",
      "title": "Table Story",
      "subtitle": "Menu-led hospitality"
    },
    "tokens": {
      "accent": "#76351f",
      "accentStrong": "#572614",
      "surface": "#f8f0e8",
      "surfaceStrong": "#fffaf5",
      "surfaceMuted": "#ead8c9",
      "text": "#2e1e16",
      "muted": "#7d675d",
      "copy": "#62473d",
      "border": "#dcc7b7",
      "highlight": "#d69a5d",
      "heroSurface": "#76351f",
      "heroText": "#ffffff",
      "cardSurface": "#fffaf5"
    },
    "components": {
      "hero": "story",
      "section": "hospitality",
      "card": "menu",
      "stats": "dense",
      "cta": "band",
      "gallery": "showcase"
    },
    "starterPages": {}
  },
  {
    "id": "corporate_services",
    "labelKey": "project.builder.themePresets.corporate_services.label",
    "descriptionKey": "project.builder.themePresets.corporate_services.description",
    "preview": {
      "accentColor": "#203245",
      "surfaceColor": "#eef2f6",
      "title": "Signal Office",
      "subtitle": "Agency default"
    },
    "tokens": {
      "accent": "#203245",
      "accentStrong": "#152433",
      "surface": "#eef2f6",
      "surfaceStrong": "#ffffff",
      "surfaceMuted": "#dfe6ed",
      "text": "#172331",
      "muted": "#617181",
      "copy": "#50606f",
      "border": "#d3dce5",
      "highlight": "#5d8ab3",
      "heroSurface": "#203245",
      "heroText": "#ffffff",
      "cardSurface": "#ffffff"
    },
    "components": {
      "hero": "office",
      "section": "default",
      "card": "default",
      "stats": "calm",
      "cta": "band",
      "gallery": "default"
    },
    "starterPages": {}
  }
] as const;
